"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
require("../../styles/components/add-fab-button.less");
const OptionIcon = ({ iconType, icon, imageSrc, label }) => {
    switch (iconType) {
        case 'material-icons':
            return react_1.default.createElement("i", { className: "material-icons" }, icon);
        case 'image-icon':
            return react_1.default.createElement("img", { className: "option-image", src: imageSrc, alt: label });
        default:
            return react_1.default.createElement("i", { className: `fa ${icon}` });
    }
};
const ButtunIcon = ({ children, ...props }) => react_1.default.createElement("div", { ...props }, children);
const AddFabButton = ({ isAddDisabled, positionTop, positionRight, zIndex, options }) => {
    const [hover, setHover] = (0, react_1.useState)(false);
    const onHover = (0, react_1.useCallback)(() => {
        if (!isAddDisabled) {
            setHover(true);
        }
    }, [isAddDisabled]);
    const removeHover = (0, react_1.useCallback)(() => {
        setHover(false);
    }, []);
    const styleObject = (0, react_1.useMemo)(() => {
        const style = {};
        if (zIndex) {
            style.zIndex = zIndex;
        }
        if (positionTop) {
            style.top = positionTop;
        }
        if (positionRight) {
            style.right = positionRight;
        }
        return style;
    }, [positionTop, positionRight, zIndex]);
    if (!options?.length) {
        return '';
    }
    return (react_1.default.createElement("div", { style: styleObject, className: (0, classnames_1.default)('add-fab-button-wrapper', { 'manual-hover': hover }), onMouseLeave: removeHover },
        react_1.default.createElement(ButtunIcon, { className: `circle-plus-button ${isAddDisabled ? 'disabled' : ''}`, onMouseOver: onHover, onFocus: noop_1.default, style: hover ? { background: options[0].background } : {}, onClick: options[0].onClick, tooltip: options[0].label }, hover ? (react_1.default.createElement(OptionIcon, { ...options[0] })) : (react_1.default.createElement("i", { className: "material-icons" }, "add"))),
        options.slice(1, options.length).map((option, index) => (react_1.default.createElement(ButtunIcon, { key: index, className: "fab-smaller-option", onClick: option.onClick, tooltip: option.label },
            react_1.default.createElement(OptionIcon, { ...option }))))));
};
AddFabButton.propTypes = {
    options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        onClick: prop_types_1.default.func.isRequired,
        label: prop_types_1.default.string,
        icon: prop_types_1.default.string,
        iconType: prop_types_1.default.string,
    })),
    positionTop: prop_types_1.default.number,
    positionRight: prop_types_1.default.number,
    isAddDisabled: prop_types_1.default.bool,
};
AddFabButton.defaultProps = {
    options: [],
    positionTop: -32,
    positionRight: 10,
    isAddDisabled: false,
};
exports.default = AddFabButton;
//# sourceMappingURL=add-fab-button.js.map